import { gql } from '@apollo/client';

export const DIPLOMA_FRAGMENT = gql`
  fragment diplomaFragment on Diploma {
      _id
      school {
        _id
        name
        logo
      }
      title
      description
      city
      result
      type
      profession {
        _id
        professionName
      }
      startDate
      endDate
      file {
        _id
        url
        name 
        size
        mimetype
      }
  }
`;

export const DIPLOMA_PUBLIC_FRAGMENT = gql`
  fragment diplomaFragment on DiplomaPublic {
      _id
      school {
        _id
        name
        logo
      }
      title
      description
      city
      result
      type
      profession {
        _id
        professionName
      }
      startDate
      endDate
  }
`;


export const ADD_DIPLOMA_TALENT = gql`
  mutation addDiplomaTalent($diplomaInput: DiplomaInput, $talentId: ID) {
    addDiplomaTalent(diplomaInput: $diplomaInput, talentId: $talentId) {
      ...diplomaFragment
    }
  }
  ${DIPLOMA_FRAGMENT}
`;

export const UPDATE_DIPLOMA_TALENT = gql`
  mutation updateDiplomaTalent($_id: ID!, $diplomaInput: DiplomaInput, $talentId: ID) {
    updateDiplomaTalent(_id: $_id, diplomaInput: $diplomaInput, talentId: $talentId) {
      ...diplomaFragment
    }
  }
  ${DIPLOMA_FRAGMENT}
`;

export const DELETE_DIPLOMA_TALENT = gql`
  mutation deleteDiplomaTalent($_id: ID!, $talentId: ID) {
    deleteDiplomaTalent(_id: $_id, talentId: $talentId) {
      ...diplomaFragment
    }
  }
  ${DIPLOMA_FRAGMENT}
`;
